/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  Table
} from 'react-bootstrap'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { ChevronUp, ChevronDown } from 'lucide-react'
import api from '../../../config/AxiosInstance'
import Loading from '../../../components/atoms/Loading'
import toast, { Toaster } from 'react-hot-toast'
import { Formik } from 'formik'
import { CreateMaterialRejectSchema } from '../../../utils/validationSchema'
import SelectInput from '../../../components/Input/SelectInput'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const StyledDetailField = ({ label, value, col = 3, children }) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>{label}</Form.Label>
      <div
        className="px-0"
        style={{
          fontSize: '0.9rem',
          fontWeight: '500',
          color: '#212529',
          minHeight: '24px'
        }}
      >
        {children ? children : value}
      </div>
    </Form.Group>
  )
}

function CreateMaterialRejectPage() {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [loading, setLoading] = useState({
    page: false,
    submit: false
  })
  const [itemCollapse, setItemCoa] = useState(true)
  const [warehouses, setWarehouses] = useState(null)
  const [seriesNumber, setSeriesNumber] = useState(null)
  const [data, setData] = useState(null)
  const renderDestArea = (
    item,
    index,
    handleChange,
    setFieldValue,
    setFieldTouched
  ) => {
    return (
      <div key={`${item.pick_up_command_id}`}>
        <Form.Select
          name="area_id"
          aria-label="destination area"
          disabled={!item.total_pack}
          onChange={(e) =>
            setFieldValue(`items[${index}].area_id`, e.target.value)
          }
          onBlur={() => setFieldTouched(`items[${index}].area_id`)}
          value={item.area_id || ''}
        >
          <option value="">Select Destination Area</option>
          {warehouses?.map((warehouse) => (
            <option key={warehouse.id} value={warehouse.id}>
              {warehouse.name}
            </option>
          ))}
        </Form.Select>
      </div>
    )
  }
  const renderRemark = (
    item,
    index,
    handleChange,
    setFieldValue,
    setFieldTouched
  ) => {
    return (
      <div key={`${item.pick_up_command_id}`}>
        <Form.Control
          type="text"
          name="remark"
          placeholder="Input Remark"
          onChange={(e) =>
            setFieldValue(`items[${index}].remark`, e.target.value)
          }
          onBlur={() => setFieldTouched(`items[${index}].remark`)}
          value={item.remark || ''}
        />
      </div>
    )
  }
  const columnItem = [
    {
      key: 'sequence',
      label: 'No'
    },
    {
      key: 'item_name',
      label: 'Item'
    },
    {
      key: 'batch',
      label: 'Batch'
    },
    {
      key: 'total_qty',
      label: 'Total Qty',
      component: (item) => Number(item.total_qty)
    },
    {
      key: 'dest_area',
      label: 'Destination Area'
    },
    {
      key: 'remark',
      label: 'Remark'
    }
  ]
  const fetchData = async () => {
    try {
      setLoading((prev) => ({ ...prev, page: true }))
      const res = await api.get(
        `inbound/material-reject/${state?.dcId?.value}/items`
      )
      const { data } = res
      if (data?.success) {
        if (!warehouses?.length || !warehouses) {
          fetchWarehouses(data?.data?.target_warehouse_baj || '')
        }
        setData(data.data)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || error.message || 'And error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      navigate('/inbound/material-reject', {
        replace: true,
        state: state.filter
      })
    } finally {
      setLoading((prev) => ({ ...prev, page: false }))
    }
  }
  const fetchSeries = async () => {
    try {
      const res = await api.get(
        `inbound/material-reject/${state?.dcId?.value}/show-series/mr`
      )
      const { data } = res.data
      const series = data.map((item) => ({
        ...item,
        label: item.name,
        value: item.name
      }))
      setSeriesNumber(series)
    } catch (err) {
      const errMsg =
        err?.response?.data?.errors?.message ||
        err?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }
  const fetchWarehouses = async (warehouseId) => {
    try {
      const params = {
        id: warehouseId
      }
      const res = await api.get('/master/area/all', { params })
      const { data: dataWarehouse } = res
      if (dataWarehouse?.success) {
        setWarehouses(
          dataWarehouse.data.filter((item) => /KR|RJ/i.test(item.code))
        )
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.errors?.message ||
        err?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }
  const handleSubmit = async (values) => {
    try {
      setLoading((prev) => ({ ...prev, submit: true }))
      const res = await api.post('inbound/material-reject', values)
      const { data } = res
      if (data?.success) {
        toast.success('MR Created!', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        navigate('/inbound/material-reject', {
          replace: true,
          state: state.filter
        })
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || error.message || 'And error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prev) => ({ ...prev, submit: false }))
    }
  }
  useEffect(() => {
    fetchData()
    if (!seriesNumber?.length || !seriesNumber) {
      fetchSeries()
    }
  }, [state])

  if (loading.page) {
    return <Loading />
  }
  return (
    <Container>
      <Toaster />
      <Row>
        <Col md={12}>
          <div className="d-flex justify-content-between">
            <div className="d-flex flex-column justify-content-start">
              <h6 className="header-title-style" style={{ fontSize: '18px' }}>
                Create MR
              </h6>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb fs-6">
                  <li className="breadcrumb-item">
                    <Link
                      to="/inbound/material-reject"
                      state={state.filter}
                      className="text-decoration-none"
                    >
                      <span className="text-black fw-bold text-uppercase">
                        Material Reject
                      </span>
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item sj-item active text-uppercase"
                    aria-current="page"
                  >
                    Create Material Reject
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Formik
          initialValues={{
            dc_id: data?.dc_id || '',
            series_number: '',
            items: data?.items?.length
              ? data?.items?.map((item) => {
                  return {
                    pick_up_command_id: item.pick_up_command_id,
                    item_batch_id: item.item_batch_id,
                    area_id: item.area_id,
                    total_qty: Number(item.total_qty),
                    total_pack: item.total_pack,
                    remark: item?.remark || null
                  }
                })
              : []
          }}
          validateOnChange={true}
          validationSchema={CreateMaterialRejectSchema}
          onSubmit={(values) => {
            handleSubmit(values)
          }}
          enableReinitialize={true}
          initialTouched={{
            dc_id: true,
            series_number: false,
            items: data?.items?.map((item) => ({
              pick_up_command_id: true,
              item_batch_id: true,
              area_id: false,
              total_qty: true,
              total_pack: true,
              remark: false
            }))
          }}
          validateOnMount={true}
        >
          {({
            handleBlur,
            handleSubmit,
            handleChange,
            values,
            errors,
            touched,
            isValid,
            setFieldValue,
            setFieldTouched,
            dirty
          }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Card style={cardStyle}>
                  <Row>
                    <SelectInput
                      label="Series Number"
                      name="series_number"
                      id="series_number"
                      value={values?.series_number || ''}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      options={seriesNumber}
                      col={4}
                    />
                    <StyledDetailField
                      label="Source Warehouse"
                      value={data?.src_warehouse || ''}
                      col={4}
                    />
                    <StyledDetailField
                      label="target warehouse"
                      value={data?.target_warehouse || ''}
                      col={4}
                    />
                    <StyledDetailField
                      label="wms dc"
                      value={data?.wms_dc_no || ''}
                      col={4}
                    />
                    <StyledDetailField
                      label="driver"
                      value={data?.driver || ''}
                      col={4}
                    />
                    <StyledDetailField
                      label="car"
                      value={data?.vehicle}
                      col={4}
                    />
                  </Row>
                </Card>
                <Card style={cardStyle} className="mt-3">
                  <Row className="mb-3">
                    <Col md={12}>
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="fw-bold text-uppercase mb-0">Item</h6>
                        <Button
                          variant="transparent"
                          className="p-0"
                          style={{ marginTop: '-0.2rem' }}
                        >
                          {itemCollapse ? (
                            <ChevronUp
                              size={16}
                              className="ms-1"
                              onClick={() => setItemCoa(!itemCollapse)}
                              style={{ cursor: 'pointer' }}
                            />
                          ) : (
                            <ChevronDown
                              size={16}
                              className="ms-1"
                              onClick={() => setItemCoa(!itemCollapse)}
                              style={{ cursor: 'pointer' }}
                            />
                          )}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Collapse in={itemCollapse}>
                    <div>
                      <Table responsive hover className="mb-0">
                        <thead className="table-secondary">
                          <tr>
                            {columnItem.map((column) => (
                              <th
                                className="align-middle p-2"
                                key={column.key}
                                style={tableHeaderStyle}
                              >
                                <span>{column.label}</span>
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.items?.length === 0 && (
                            <tr>
                              <td colSpan={columnItem.length} className="p-3">
                                <div className="d-flex justify-content-center">
                                  <span className="text-secondary">
                                    No data available
                                  </span>
                                </div>
                              </td>
                            </tr>
                          )}
                          {data?.items?.length > 0 &&
                            data?.items?.map((item, index) => (
                              <tr key={`${item.id}-${index}`}>
                                {columnItem.map((column) => (
                                  <td
                                    key={column.key}
                                    className="p-2 align-middle"
                                  >
                                    {column.key === 'sequence' && index + 1}
                                    {column.key === 'remark' &&
                                      renderRemark(
                                        values.items[index],
                                        index,
                                        handleChange,
                                        setFieldValue,
                                        setFieldTouched
                                      )}
                                    {column.key === 'dest_area' &&
                                      renderDestArea(
                                        values.items[index],
                                        index,
                                        handleChange,
                                        setFieldValue,
                                        setFieldTouched
                                      )}
                                    {column.component && column.component(item)}
                                    {![
                                      'sequence',
                                      'remark',
                                      'dest_area'
                                    ].includes(column.key) &&
                                      !column.component &&
                                      item[column.key]}
                                  </td>
                                ))}
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </div>
                  </Collapse>
                </Card>
                <Row className="my-3">
                  <Col md={12} className="d-flex justify-content-between">
                    <Button
                      variant="transparent"
                      className="text-danger fw-bold"
                      onClick={(e) => {
                        e.preventDefault()
                        navigate('/inbound/material-reject', {
                          replace: true,
                          state: state.filter
                        })
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="transparent"
                      type="submit"
                      className={`${
                        !isValid || !dirty || loading.submit
                          ? 'btn-secondary opacity-25'
                          : 'btn-primary-orange'
                      }`}
                      disabled={!isValid || !dirty || loading.submit}
                    >
                      {loading.submit ? 'Submitting...' : 'Submit'}
                    </Button>
                  </Col>
                </Row>
              </Form>
            )
          }}
        </Formik>
      </Row>
    </Container>
  )
}

export default CreateMaterialRejectPage
